(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var STORAGE_KEY_PREFIX = 'announcement-dismissed-';
    var INTERVAL_MS = 4000;
    var FADE_MS = 500;

    function initAnnouncementBar(section) {
      var sectionId = section.dataset.sectionId;
      var storageKey = STORAGE_KEY_PREFIX + sectionId;

      // Check dismissal state
      try {
        if (sessionStorage.getItem(storageKey) === '1') {
          section.classList.add('is-dismissed');
          return;
        }
      } catch (e) {}

      // Wire up close button
      var closeBtn = section.querySelector('[data-close-bar]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          section.classList.add('is-dismissed');
          try {
            sessionStorage.setItem(storageKey, '1');
          } catch (e) {}
        });
      }

      // Message rotation — skip if reduced motion or only one message
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var messages = Array.prototype.slice.call(section.querySelectorAll('[data-message-index]'));

      if (prefersReducedMotion || messages.length <= 1) {
        return;
      }

      var currentIndex = 0;
      var timer = null;

      function showMessage(index) {
        messages.forEach(function (msg, i) {
          var isActive = i === index;
          msg.classList.toggle('is-active', isActive);
          msg.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          // Update tabindex on any links inside
          var links = msg.querySelectorAll('a');
          links.forEach(function (link) {
            link.setAttribute('tabindex', isActive ? '0' : '-1');
          });
        });
      }

      function advance() {
        currentIndex = (currentIndex + 1) % messages.length;
        showMessage(currentIndex);
      }

      function startRotation() {
        timer = setInterval(advance, INTERVAL_MS);
      }

      function stopRotation() {
        if (timer !== null) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Pause on hover / focus for accessibility
      section.addEventListener('mouseenter', stopRotation);
      section.addEventListener('focusin', stopRotation);
      section.addEventListener('mouseleave', startRotation);
      section.addEventListener('focusout', function (e) {
        if (!section.contains(e.relatedTarget)) {
          startRotation();
        }
      });

      // Set transition duration from constant to keep CSS and JS in sync
      messages.forEach(function (msg) {
        msg.style.transitionDuration = FADE_MS + 'ms';
      });

      startRotation();
    }

    function init() {
      var bars = document.querySelectorAll('[data-announcement-bar]');
      bars.forEach(function (bar) {
        initAnnouncementBar(bar);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Shopify theme editor live reload support
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-announcement-bar]');
      if (section) {
        initAnnouncementBar(section);
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  'use strict';

  /* ── Cached elements ─────────────────────────────────── */
  const header         = document.getElementById('site-header');
  const menuToggle     = document.querySelector('[data-menu-toggle]');
  const menuClose      = document.querySelector('[data-menu-close]');
  const mobileMenu     = document.getElementById('mobile-menu');
  const menuBackdrop   = document.querySelector('[data-menu-backdrop]');
  const searchToggle   = document.querySelector('[data-search-toggle]');
  const searchClose    = document.querySelector('[data-search-close]');
  const searchOverlay  = document.getElementById('search-overlay');
  const searchInput    = document.querySelector('[data-search-input]');
  const navTriggers    = document.querySelectorAll('[data-nav-trigger]');
  const mobileParents  = document.querySelectorAll('[data-mobile-parent]');

  /* ── Mobile menu ──────────────────────────────────────── */
  function openMobileMenu() {
    if (!mobileMenu || !menuToggle) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuBackdrop && menuBackdrop.classList.add('is-visible');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.setAttribute('data-menu-open', '');
    if (window.MP && window.MP.lock) window.MP.lock();

    // Focus first focusable element
    const firstFocusable = mobileMenu.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      requestAnimationFrame(function () { firstFocusable.focus(); });
    }

    // Trap focus
    document.addEventListener('keydown', trapFocusMobileMenu);
  }

  function closeMobileMenu() {
    if (!mobileMenu || !menuToggle) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuBackdrop && menuBackdrop.classList.remove('is-visible');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('data-menu-open');
    if (window.MP && window.MP.unlock) window.MP.unlock();
    menuToggle.focus();
    document.removeEventListener('keydown', trapFocusMobileMenu);
  }

  function trapFocusMobileMenu(e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      return;
    }
    if (e.key !== 'Tab') return;
    if (!mobileMenu) return;

    const focusableSelectors = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
    const focusables = Array.from(mobileMenu.querySelectorAll(focusableSelectors))
      .filter(function (el) { return !el.closest('[hidden]') && !el.closest('[aria-hidden="true"]'); });

    if (!focusables.length) return;

    const first = focusables[0];
    const last  = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      const isOpen = mobileMenu && mobileMenu.classList.contains('is-open');
      if (isOpen) { closeMobileMenu(); } else { openMobileMenu(); }
    });
  }

  if (menuClose) {
    menuClose.addEventListener('click', closeMobileMenu);
  }

  if (menuBackdrop) {
    menuBackdrop.addEventListener('click', closeMobileMenu);
  }

  /* ── Mobile sub-nav accordion ───────────────────────── */
  mobileParents.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const subList  = trigger.nextElementSibling;

      // Close all others
      mobileParents.forEach(function (other) {
        if (other !== trigger) {
          other.setAttribute('aria-expanded', 'false');
          const otherSub = other.nextElementSibling;
          if (otherSub) otherSub.hidden = true;
        }
      });

      trigger.setAttribute('aria-expanded', String(!expanded));
      if (subList) subList.hidden = expanded;
    });
  });

  /* ── Search overlay ──────────────────────────────────── */
  function openSearch() {
    if (!searchOverlay || !searchToggle) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchToggle.setAttribute('aria-expanded', 'true');
    if (window.MP && window.MP.lock) window.MP.lock();

    if (searchInput) {
      requestAnimationFrame(function () { searchInput.focus(); });
    }

    document.addEventListener('keydown', handleSearchKeydown);
  }

  function closeSearch() {
    if (!searchOverlay || !searchToggle) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchToggle.setAttribute('aria-expanded', 'false');
    if (window.MP && window.MP.unlock) window.MP.unlock();
    searchToggle.focus();
    document.removeEventListener('keydown', handleSearchKeydown);
  }

  function handleSearchKeydown(e) {
    if (e.key === 'Escape') closeSearch();
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      const isOpen = searchOverlay && searchOverlay.classList.contains('is-open');
      if (isOpen) { closeSearch(); } else { openSearch(); }
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  /* ── Desktop dropdown keyboard nav ──────────────────── */
  navTriggers.forEach(function (trigger) {
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        // Close all other triggers first
        navTriggers.forEach(function (other) {
          if (other !== trigger) {
            other.setAttribute('aria-expanded', 'false');
          }
        });
        trigger.setAttribute('aria-expanded', String(!expanded));
      }
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    // Close dropdown when focus leaves parent li
    const parentLi = trigger.closest('.site-header__nav-item');
    if (parentLi) {
      parentLi.addEventListener('focusout', function (e) {
        if (!parentLi.contains(e.relatedTarget)) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // Close desktop dropdowns on Escape anywhere in header
  if (header) {
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        navTriggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  /* ── Listen for global overlay:close event ──────────── */
  if (window.MP && window.MP.on) {
    window.MP.on('overlay:close', function () {
      closeMobileMenu();
      closeSearch();
    });
  }

  /* ── Close on click outside search overlay ──────────── */
  if (searchOverlay) {
    document.addEventListener('click', function (e) {
      if (
        searchOverlay.classList.contains('is-open') &&
        !searchOverlay.contains(e.target) &&
        e.target !== searchToggle &&
        !searchToggle.contains(e.target)
      ) {
        closeSearch();
      }
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  'use strict';

  // ── Helpers ──────────────────────────────────────────────
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // ── Gallery ──────────────────────────────────────────────
  function initGallery(section) {
    var mainImg   = qs('[data-gallery-main-img]', section);
    var thumbs    = qsa('[data-gallery-thumb]', section);
    var images    = [];

    // Build image list from DOM (thumbnail src data)
    thumbs.forEach(function (thumb) {
      var img = qs('img', thumb);
      if (img) images.push(img.src);
    });

    if (!mainImg || thumbs.length === 0) return;

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        var img = qs('img', thumb);
        if (!img || !mainImg) return;

        // Swap src — use the full-size version derived from thumbnail URL
        var fullSrc = img.src.replace(/width=\d+/, 'width=1200');
        mainImg.src = fullSrc;
        mainImg.alt = img.alt;

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ── Variant Picker ───────────────────────────────────────
  function initVariants(section) {
    var jsonEl   = qs('[data-product-json]', section);
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    if (!variants || variants.length === 0) return;

    var variantIdInput  = qs('[data-variant-id]', section);
    var addToCartBtn    = qs('[data-add-to-cart]', section);
    var priceContainer  = qs('[data-price-container]', section);
    var optionBtns      = qsa('[data-option-btn]', section);

    // Track selected options
    var selectedOptions = [];

    // Seed from buttons that are pre-selected in HTML
    optionBtns.forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      if (btn.classList.contains('is-selected')) {
        selectedOptions[idx] = btn.getAttribute('data-option-value');
      }
    });

    // Also read the number of options from the first variant
    var optionCount = variants[0] ? variants[0].options.length : 0;

    // Fill any gaps
    for (var i = 0; i < optionCount; i++) {
      if (selectedOptions[i] === undefined) {
        // Find first available value for this option
        var firstBtn = qs('[data-option-btn][data-option-index="' + i + '"]', section);
        if (firstBtn) selectedOptions[i] = firstBtn.getAttribute('data-option-value');
      }
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          return val === opts[i];
        });
      }) || null;
    }

    function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateUI(variant) {
      if (!variant) {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Unavailable';
        }
        return;
      }

      // Update hidden variant ID
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update price display
      if (priceContainer) {
        var priceHTML = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML  = '<s class="muted" aria-label="Regular price">' + formatMoney(variant.compare_at_price) + '</s>';
          priceHTML += ' <span class="accent" aria-label="Sale price">' + formatMoney(variant.price) + '</span>';
        } else {
          priceHTML = '<span>' + formatMoney(variant.price) + '</span>';
        }
        priceContainer.innerHTML = priceHTML;
      }

      // Update add to cart button
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.setAttribute('aria-disabled', 'false');
          addToCartBtn.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.setAttribute('aria-disabled', 'true');
          addToCartBtn.textContent = 'Sold Out';
        }
      }
    }

    function onOptionClick(btn) {
      var optIdx = parseInt(btn.getAttribute('data-option-index'), 10);
      var optVal = btn.getAttribute('data-option-value');

      // Update selected state for this option group
      qsa('[data-option-btn][data-option-index="' + optIdx + '"]', section).forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      selectedOptions[optIdx] = optVal;

      // Update the label's selected-val span
      var valSpan = qs('[data-selected-val="' + optIdx + '"]', section);
      if (valSpan) valSpan.textContent = optVal;

      var matched = findVariant(selectedOptions);
      updateUI(matched);
    }

    optionBtns.forEach(function (btn) {
      if (!btn.disabled) {
        btn.addEventListener('click', function () { onOptionClick(btn); });
      }
    });

    // Initial state: set from first available variant
    var initialVariant = findVariant(selectedOptions);
    if (initialVariant) updateUI(initialVariant);
  }

  // ── Qty Stepper ──────────────────────────────────────────
  function initQty(section) {
    var containers = qsa('[data-qty]', section);
    containers.forEach(function (container) {
      var input = qs('input[type="number"]', container);
      if (!input) return;

      qsa('[data-qty-step]', container).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step  = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          var value = parseInt(input.value, 10) || 1;
          var min   = parseInt(input.min, 10) || 1;
          var next  = Math.max(min, value + step);
          input.value = next;
        });
      });
    });
  }

  // ── Accordions ───────────────────────────────────────────
  function initAccordions(section) {
    var accordions = qsa('[data-accordion]', section);
    accordions.forEach(function (acc) {
      var trigger = qs('[data-accordion-trigger]', acc);
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = acc.classList.contains('is-open');

        // Close all siblings first
        accordions.forEach(function (a) {
          a.classList.remove('is-open');
          var t = qs('[data-accordion-trigger]', a);
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          acc.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ── Reveal on Scroll ─────────────────────────────────────
  function initReveal(section) {
    var els = qsa('[data-reveal]', section);
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      els.forEach(function (el) { observer.observe(el); });
    } else {
      // Fallback: show immediately
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // ── Init ─────────────────────────────────────────────────
  function init() {
    var sections = qsa('[data-section-type="main-product"]');
    sections.forEach(function (section) {
      initGallery(section);
      initVariants(section);
      initQty(section);
      initAccordions(section);
      initReveal(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor re-render support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section && section.querySelector('[data-section-type="main-product"]')) {
      initGallery(section);
      initVariants(section);
      initQty(section);
      initAccordions(section);
      initReveal(section);
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
